import Gallery from './Gallery';
export default Gallery;
export type { GalleryTypes } from './Gallery.types';
